import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// If react-snap pre-rendered the page, hydrate to preserve existing HTML.
// Otherwise, do a normal client render.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
